// ─────────────────────────────────────────────────────────────────────────────
// Trustpilot configuration
// ─────────────────────────────────────────────────────────────────────────────
//
// Recovery Trauma™ displays ONLY real, verified Trustpilot reviews — never
// AI-generated, paraphrased, or fabricated. The live TrustBox widget pulls
// reviews directly from Trustpilot's servers using your Business Unit ID,
// which guarantees:
//
//   ✅ Real reviewer names (as published on Trustpilot)
//   ✅ Actual star ratings
//   ✅ Unedited review text
//   ✅ Direct link to the original Trustpilot review page
//
// HOW TO CONNECT THE LIVE FEED
// ────────────────────────────
// 1. Log in to https://business.trustpilot.com/
// 2. Go to Integrations → TrustBox
// 3. Choose a TrustBox (e.g. "Review Carousel")
// 4. Copy the value of `data-businessunit-id` from the generated snippet.
//    It's a public 24-character hex string (it's safe to commit — Trustpilot
//    exposes it in the rendered widget HTML).
// 5. Paste it below as TRUSTPILOT_BUSINESS_UNIT_ID, OR set the env var
//    VITE_TRUSTPILOT_BUSINESS_UNIT_ID at build time.
//
// Until a real ID is set, the page shows a clean CTA card linking to the
// public Trustpilot profile — never fake or placeholder reviews.

export const TRUSTPILOT_BUSINESS_UNIT_ID: string =
  (import.meta.env.VITE_TRUSTPILOT_BUSINESS_UNIT_ID as string | undefined) ||
  // ⬇️ Paste your Business Unit ID between the quotes to enable the live feed.
  // Until set, the page shows a clean link-out to the public Trustpilot
  // profile — never fake or AI-generated reviews.
  "";

export const TRUSTPILOT_PROFILE_URL =
  "https://uk.trustpilot.com/review/recoverytrauma.com";

// TrustBox template IDs (public, documented by Trustpilot).
// https://support.trustpilot.com/hc/en-us/articles/115011421468
export const TRUSTBOX_TEMPLATES = {
  /** Horizontal scrolling carousel of recent 4–5★ reviews. */
  carousel: "53aa8912dec7e10d38f59f36",
  /** Grid/list of the most recent reviews. */
  list: "539ad60defb9600b94d7df2c",
  /** Compact "micro" star rating badge. */
  microStar: "5419b6ffb0d04a076446a9af",
  /** Larger "mini" trust score widget. */
  mini: "53aa8807dec7e10d38f59f32",
} as const;

export const isTrustpilotLive = (): boolean =>
  TRUSTPILOT_BUSINESS_UNIT_ID.trim().length > 0;

// ─────────────────────────────────────────────────────────────────────────────
// Verified Trustpilot reviews (transcribed verbatim from the public profile).
// These are REAL published reviews — never edit the wording, never add reviews
// that are not published on Trustpilot.
// ─────────────────────────────────────────────────────────────────────────────
export type VerifiedTrustpilotReview = {
  author: string;
  location: string;
  rating: number;
  title: string;
  body: string;
  date: string; // ISO date of the published review
};

export const VERIFIED_TRUSTPILOT_REVIEWS: VerifiedTrustpilotReview[] = [
  {
    author: "Ian",
    location: "GB",
    rating: 5,
    title: "I really love the Dream Journal on the…",
    body: "I really love the Dream Journal on the website 😍 And the Shadow Work section too",
    date: "2026-08-25",
  },
  {
    author: "SandyCroft",
    location: "GB",
    rating: 5,
    title: "Great",
    body: "Honestly, I really love using the Recovery Trauma website. You can proper tell it's been made with loads of love and passion, and that really comes through. I mostly use the journal and I'm really into it — I find it proper reflective and it gives me a chance to slow down, have a think and check in with myself. It feels genuine, thoughtful and like someone's actually put their heart into it. Really rate it!",
    date: "2026-08-12",
  },
];

